import React from "react";
import Loadable from "react-loadable";

import { WholePageLoader } from "@exo/loading-spinner";

const Loading = (props) => {
	if (props.error) {
		console.error("Loading Error", props.error);
		return <WholePageLoader />;
	} else {
		return <WholePageLoader />;
	}
};

// A separate setup loader per project. This sets the API endpoints.
// Loading them dynamically should theoretically be more secure

const AfricomSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/africomApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const BalticsDemoSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/balticsDemoApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const BCBSSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/bcbsApi.js"),
		customLogo: () => import(/* webpackChunkName: "setup" */ "assets/images/svg/calibrate.svg"),
		projectTheme: () => import(/* webpackChunkName: "setup" */ "config/projectVars/sevenTwenty.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		const logo = loaded.customLogo.default;
		const theme = loaded.projectTheme.default;
		return <Setup api={api} customLogo={logo} projectTheme={theme} />;
	},
});

const CBPSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/cbpApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const ChinaSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/chinaApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});
const Australia2022SetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/australia2022Api.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});
const Koala2022SetupLoader = Loadable.Map({
        loader: {
                SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
                api: () => import(/* webpackChunkName: "setup" */ "lib/api/koalaApi.js"),
        },
        loading: Loading,
        render(loaded, props) {
                const Setup = loaded.SetupComponent.default;
                const api = loaded.api.default;
			
                return <Setup api={api} />;
        },
});
const PnnlSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/chinaApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const CraftsmanSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/craftsmanApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const DcccSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/bcbsApi.js"),
		customLogo: () => import(/* webpackChunkName: "setup" */ "assets/images/svg/calibrate.svg"),
		projectTheme: () => import(/* webpackChunkName: "setup" */ "config/projectVars/sevenTwenty.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		const logo = loaded.customLogo.default;
		const theme = loaded.projectTheme.default;
		return <Setup api={api} customLogo={logo} projectTheme={theme} />;
	},
});
const GECSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/gecApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const GECAnaystSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/gecApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const DcosSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/dcosApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const KabulSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/kabulApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const IslamabadSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/islamabadApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});


const BrazilSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/brasiliaApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const AatfSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/aatfApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const AfghanistanSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/afghanistandemoApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const AfghanistanDFATSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/afghanistanDFATApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const MidtermsSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/midterms.js"),
		customLogo: () => import(/* webpackChunkName: "setup" */ "assets/images/svg/calibrate.svg"),
		projectTheme: () => import(/* webpackChunkName: "setup" */ "config/projectVars/sevenTwenty.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		const logo = loaded.customLogo.default;
		const theme = loaded.projectTheme.default;
		return <Setup api={api} customLogo={logo} projectTheme={theme} />;
	},
});

const MFSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/mfApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const MFTranslateSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/mfTranslateApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const NESTSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/nestApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const NESTMongoliaSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/nestMongoliaApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const UsccSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/uscc23Api.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const DemoSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/demoApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const SevenTwentyLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/sevenTwenty.js"),
		customLogo: () => import(/* webpackChunkName: "setup" */ "assets/images/svg/calibrate.svg"),
		projectTheme: () => import(/* webpackChunkName: "setup" */ "config/projectVars/sevenTwenty.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		const logo = loaded.customLogo.default;
		const theme = loaded.projectTheme.default;
		return <Setup api={api} customLogo={logo} projectTheme={theme} />;
	},
});

const SevenTwentyUSCCLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/sevenTwenty_uscc.js"),
		customLogo: () => import(/* webpackChunkName: "setup" */ "assets/images/svg/calibrate.svg"),
		projectTheme: () => import(/* webpackChunkName: "setup" */ "config/projectVars/sevenTwenty.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		const logo = loaded.customLogo.default;
		const theme = loaded.projectTheme.default;
		return <Setup api={api} customLogo={logo} projectTheme={theme} />;
	},
});

const UsipSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/usipApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const IraqSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/iraqApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const Politics2020Loader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/politics2020Api.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const Politics2020LiveLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/politics2020LiveApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const RussiaSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/russiaApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});


const OseRussiaSetupLoader = Loadable.Map({
        loader: {
                SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
                api: () => import(/* webpackChunkName: "setup" */ "lib/api/OseRussiaApi.js"),
        },
        loading: Loading,
        render(loaded, props) {
                const Setup = loaded.SetupComponent.default;
                const api = loaded.api.default;
                return <Setup api={api} />;
        },
});

const OseKabulSetupLoader = Loadable.Map({
        loader: {
                SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
                api: () => import(/* webpackChunkName: "setup" */ "lib/api/OseKabulApi.js"),
        },
        loading: Loading,
        render(loaded, props) {
                const Setup = loaded.SetupComponent.default;
                const api = loaded.api.default;
                return <Setup api={api} />;
        },
});

const OseAusChinaSetupLoader = Loadable.Map({
        loader: {
                SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
                api: () => import(/* webpackChunkName: "setup" */ "lib/api/OseAusChinaApi.js"),
        },  
        loading: Loading,
        render(loaded, props) { 
                const Setup = loaded.SetupComponent.default;
                const api = loaded.api.default;
                return <Setup api={api} />;
        },
});



const ScaSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/bscaApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const VenezuelaSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/venezuelaApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

// Same as VenezuelaSetupLoader, except with a customLogo
const SayaraSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/venezuelaApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const USPoliticsLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/usPoliticsApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const WalmartLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		customLogo: () => import(/* webpackChunkName: "setup" */ "assets/images/intel471_logo.png"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/walmartApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		const logo = loaded.customLogo.default;
		return <Setup api={api} customLogo={logo} />;
	},
});

const SetupLoader = ({ currentProject }) => {
	return currentProject === "texas23" ? (
		<UsccSetupLoader />
	) : currentProject === "africom" ? (
		<AfricomSetupLoader />
	) : currentProject === "cbp" ? (
		<CBPSetupLoader />
	) : currentProject === "balticsDemo" ? (
		<BalticsDemoSetupLoader />
	) : currentProject === "bcbs" ? (
		<BCBSSetupLoader />
	) : currentProject === "china" ? (
		<ChinaSetupLoader />
	) : currentProject === "pnnl" ? (
		<PnnlSetupLoader />
	) : currentProject === "dccc" ? (
		<DcccSetupLoader />
	) : currentProject === "dcos" ? (
		<DcosSetupLoader />
	) : currentProject === "gec" ? (
		<GECSetupLoader />
	) : currentProject === "gec_analyst" ? (
		<GECAnaystSetupLoader />
	) : currentProject === "iraq" ? (
		<IraqSetupLoader />
	) : currentProject === "kabul" ? (
		<KabulSetupLoader />
	) : currentProject === "islamabad" ? (
		<IslamabadSetupLoader />
	) : currentProject === "oseRussia" ? (
                <OseRussiaSetupLoader />
	) : currentProject === "oseAusChina" ? (
                <OseAusChinaSetupLoader />
	) : currentProject === "oseKabul" ? (
                <OseKabulSetupLoader />
	) : currentProject === "brasilia" ? (
		<BrazilSetupLoader />
	) : currentProject === "aatf" ? (
		<AatfSetupLoader />
	) : currentProject === "australia2022" ? (
		<Australia2022SetupLoader />
	) : currentProject === "koala" ? (
                <Koala2022SetupLoader />
	) : currentProject === "afghanistandemo" ? (
		<AfghanistanSetupLoader />
	) : currentProject === "afghanistanDFAT" ? (
		<AfghanistanDFATSetupLoader />
	) : currentProject === "craftsman" ? (
		<CraftsmanSetupLoader />
	) : currentProject === "usip" ? (
		<UsipSetupLoader />
	) : currentProject === "sevenTwenty" ? (
		<SevenTwentyLoader />
	) : currentProject === "sevenTwenty_uscc" ? (
		<SevenTwentyUSCCLoader />
	) : currentProject === "midterms" ? (
		<MidtermsSetupLoader />
	) : currentProject === "mf" ? (
		<MFSetupLoader />
	) : currentProject === "mf_translate" ? (
		<MFTranslateSetupLoader />
	) : currentProject === "nest" ? (
		<NESTSetupLoader />
	) : currentProject === "nest_mongolia" ? (
		<NESTMongoliaSetupLoader />
	) : currentProject === "venezuela" ? (
		<VenezuelaSetupLoader />
	) : currentProject === "russia" ? (
		<RussiaSetupLoader />
	) : currentProject === "sayara" ? (
		<SayaraSetupLoader />
	) : currentProject === "bsca" ? (
		<ScaSetupLoader />
	) : currentProject === "uspol" ? (
		<USPoliticsLoader />
	) : currentProject === "politics2020" ? (
		<Politics2020Loader />
	) : currentProject === "politics2020live" ? (
		<Politics2020LiveLoader />
	) : currentProject === "walmart" ? (
		<WalmartLoader />
	) : (
		<DemoSetupLoader />
	);
};

export default SetupLoader;
